

























import { Component, Prop, Vue } from 'vue-property-decorator';
import '@/utils/filter';
import { default as axios } from 'axios';
import { CalendarCollectInterface } from '../../interfaces/calendar/calendar.interface';
import { Utils } from '../../utils/utils';
import Weather from '@/components/home/Weather.vue';

@Component({
  components: { Weather },
})
export default class SelectDay extends Vue {
  public dialog: boolean = true;
  public user: string = Utils.getCurrentUserName();
  public confirmOrDelete: string = 'Confirmer';

  @Prop(Date) readonly date!: Date;
  @Prop() readonly check!: boolean;

  public selectDay() {
    if (this.date instanceof Date) {
      const data: CalendarCollectInterface = {
        user: this.user,
        date: new Date(this.date),
      };

      if (this.check === true) {
        axios
          .delete(`${process.env.VUE_APP_API_URL}/calendars`, { data })
          .catch(err => console.error(err));
      } else {
        axios
          .post(`${process.env.VUE_APP_API_URL}/calendars`, data)
          .catch(err => console.error(err));
      }
    }

    this.closeDialog();
  }

  public closeDialog() {
    this.$emit('closeDialog');
  }
}
